import { Si1Password } from "react-icons/si"; 
import { BiLogOut } from "react-icons/bi"; 
import { CgProfile } from "react-icons/cg"; 
import React, { useState, useEffect} from 'react';
import { BiBell, BiMessageRounded } from "react-icons/bi";
import { useNavigate } from 'react-router-dom'; // Import useNavigate pour la redirection

import './headerIcons.css';

function HeaderIcons() {

     const [showMessages, setShowMessages] = useState(false);
      const [showProfileMenu, setShowProfileMenu] = useState(false);
      const [userEmail, setUserEmail] = useState("");
      const navigate = useNavigate();

       // Récupérer les informations de l'utilisateur depuis le localStorage au chargement du composant
    useEffect(() => {
      const storedUser  = localStorage.getItem('user');
      if (storedUser ) {
          const user = JSON.parse(storedUser ); // Convertir la chaîne JSON en objet
          setUserEmail(user.email); // Mettre à jour l'e-mail de l'utilisateur
      }
  }, []);

      const toggleMessagesDropdown = () => {
        setShowMessages(!showMessages);
        setShowProfileMenu(false);
      };
    
      const toggleProfileDropdown = () => {
        setShowProfileMenu(!showProfileMenu);
        setShowMessages(false);
      };

     

      const handleLogout = () => {
        // Supprimez les informations de l'utilisateur (par exemple, du localStorage)
        localStorage.removeItem('user'); // Supposons que vous stockez les informations de l'utilisateur dans localStorage
        // Redirigez l'utilisateur vers la page de connexion
        navigate('/');
    };

  return (
    <div className="header-icons">
    
            {/* Icône de notification */}
            <BiBell className="icon bell-icon" />
    
    
            {/* Icône de message avec dropdown */}
            <div className="icon-with-badge" onClick={toggleMessagesDropdown}>
              <BiMessageRounded className="icon message-icon" />
              <span className="badge">3</span>
              {showMessages && (
                <div className="dropdown messages-dropdown">
                  <div className="dropdown-item">Message 1</div>
                  <div className="dropdown-item">Message 2</div>
                  <div className="dropdown-item">Message 3</div>
                </div>
              )}
            </div>
    
            {/* Menu de profil avec dropdown */}
            <div className="user-profile" onClick={toggleProfileDropdown}>
              <span className="user-name">{userEmail || "Abba SanKaré"}</span>
              <img
                src="https://via.placeholder.com/40"
                alt="User Avatar"
                className="user-avatar"
              />
              {showProfileMenu && (
                <div className="dropdown profile-dropdown">
                  <div className="dropdown-item"><CgProfile className="picon"/>Profil</div>
                  <div className="dropdown-item"><Si1Password className="picon"/>Changer mot de passe</div>
                  <div className="dropdown-item" onClick={handleLogout}><BiLogOut className="picon"/> Déconnexion</div>
                </div>
              )}
            </div>
          </div>
  )
}

export default HeaderIcons